import { createSlice, Dispatch } from "@reduxjs/toolkit";
import { getPatientEligibilityDetails } from "../../../../shared/api/bigQuery/nycbsPharmaOrders";
import {
  mapToPatientEligibilityDetails,
  PatientEligibilityDetails,
} from "../../../data-model/patientEligibilityDetails";

interface PatientEligibilityState {
  data: PatientEligibilityDetails[] | null;
  loading: boolean;
  error: string | null;
}

const initialState: PatientEligibilityState = {
  data: null,
  loading: false,
  error: null,
};

const patientEligibilitySlice = createSlice({
  name: "patientEligibility",
  initialState,
  reducers: {
    setPatientEligibilityDetails: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    setPatientEligibilityLoading: (state, action) => {
      state.loading = action.payload;
      state.data = null;
      state.error = null;
    },
    setPatientEligibilityError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
      state.data = null;
    },
  },
});

const getIsLoading = (
  getState: () => { patientEligibility: PatientEligibilityState },
) => {
  return getState().patientEligibility.loading;
};

export const fetchPatientEligibilityDetails =
  (id: string) => async (dispatch: Dispatch, getState: any) => {
    if (getIsLoading(getState)) {
      return;
    }
    dispatch(
      patientEligibilitySlice.actions.setPatientEligibilityLoading(true),
    );
    try {
      const response = await getPatientEligibilityDetails(id);
      const allPatientEligibilityDetails = response["details"];
      console.log("allPatientEligibilityDetails", allPatientEligibilityDetails);
      if (allPatientEligibilityDetails.length > 0) {
        const eligibilityDetails = allPatientEligibilityDetails.map(
          (detail) => {
            return mapToPatientEligibilityDetails(detail);
          },
        );
        dispatch(
          patientEligibilitySlice.actions.setPatientEligibilityDetails(
            eligibilityDetails,
          ),
        );
      } else {
        dispatch(
          patientEligibilitySlice.actions.setPatientEligibilityDetails(null),
        );
      }
    } catch (error) {
      dispatch(
        patientEligibilitySlice.actions.setPatientEligibilityError(error),
      );
    }
  };

export default patientEligibilitySlice.reducer;
